import NoticeTable from '@/components/tables/notice-table';

const CourseNoticePage = () => {
  return (
    <div className="p-1 lg:p-4">
      <NoticeTable />
    </div>
  );
};

export default CourseNoticePage;
